const STAR =
  "M50 6 C55 6 58 10 60 15 L68 32 L87 35 C93 36 96 40 95 45 C94 48 92 50 90 52 L76 65 L80 84 C81 90 77 94 72 94 C70 94 68 93 66 92 L50 82 L34 92 C32 93 30 94 28 94 C23 94 19 90 20 84 L24 65 L10 52 C8 50 6 48 5 45 C4 40 7 36 13 35 L32 32 L40 15 C42 10 45 6 50 6 Z";

export const Bini = ({ size = 96, mood = "happy", className = "", ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true" {...rest}>
    <defs>
      <radialGradient id={`bg-${mood}`} cx="40%" cy="35%" r="70%">
        <stop offset="0%" stopColor={mood !== "happy" ? "#F4E3A0" : "#FFF09A"} />
        <stop offset="60%" stopColor={mood !== "happy" ? "#D9B94A" : "#FFD21F"} />
        <stop offset="100%" stopColor={mood !== "happy" ? "#B8952E" : "#F5B800"} />
      </radialGradient>
    </defs>
    <path d={STAR} fill={`url(#bg-${mood})`} stroke={mood !== "happy" ? "#A88728" : "#E9A800"} strokeWidth="2" />
    <ellipse cx="38" cy="30" rx="9" ry="5" fill="#fff" opacity={mood !== "happy" ? 0.25 : 0.6} transform="rotate(-25 38 30)" />
    {mood === "soft" ? (
      <>
        <path d="M35 53 Q40 47 45 53" stroke="#5A3A1A" strokeWidth="2.6" fill="none" strokeLinecap="round" />
        <path d="M55 53 Q60 47 65 53" stroke="#5A3A1A" strokeWidth="2.6" fill="none" strokeLinecap="round" />
        <path d="M43 63 Q50 70 57 63" stroke="#5A3A1A" strokeWidth="2.6" fill="none" strokeLinecap="round" />
      </>
    ) : mood === "sleep" ? (
      <>
        <path d="M35 52 Q40 56 45 52" stroke="#5A3A1A" strokeWidth="2.6" fill="none" strokeLinecap="round" />
        <path d="M55 52 Q60 56 65 52" stroke="#5A3A1A" strokeWidth="2.6" fill="none" strokeLinecap="round" />
        <path d="M46 66 Q50 68 54 66" stroke="#5A3A1A" strokeWidth="2.4" fill="none" strokeLinecap="round" />
      </>
    ) : (
      <>
        <ellipse cx="40" cy="51" rx="5" ry="6.5" fill="#3B2212" />
        <ellipse cx="60" cy="51" rx="5" ry="6.5" fill="#3B2212" />
        <circle cx="41.8" cy="48.5" r="2" fill="#fff" />
        <circle cx="61.8" cy="48.5" r="2" fill="#fff" />
        <path d="M42 62 Q50 72 58 62 Z" fill="#7A2A1A" />
        <path d="M45 65 Q50 69 55 65" fill="#FF7A8A" />
      </>
    )}
    <ellipse cx="31" cy="61" rx="5" ry="3" fill="#FF8FA8" opacity="0.7" />
    <ellipse cx="69" cy="61" rx="5" ry="3" fill="#FF8FA8" opacity="0.7" />
  </svg>
);

export const BiniBubble = ({ children, mood, size = 88, testId, className = "" }) => (
  <div className={`flex items-end gap-4 ${className}`} data-testid={testId}>
    <Bini size={size} mood={mood} className="shrink-0 anim-float drop-shadow-lg" />
    <div className="speech text-lg sm:text-xl font-semibold text-[#1E2A5A]">{children}</div>
  </div>
);
